import { computed } from 'vue'

import type { MenuProps } from './menu'

export default function useMenuColor(props: MenuProps) {
  const menuBarColor = computed(() => {
      return ''
  })
  return menuBarColor
}
